"use client";

import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

type Props = ComponentProps<"button"> & {
  isActive: boolean;
};

export const TabButton = ({ isActive, ...props }: Props) => (
  <button
    {...props}
    className={twMerge(
      "relative border-b-2 px-2 py-4 text-center text-sm font-medium sm:text-base",
      isActive
        ? "border-sky-600 text-sky-700"
        : "border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-800",
      props.disabled &&
        "cursor-not-allowed text-gray-400 hover:border-transparent hover:text-gray-400",
      props.className
    )}
  >
    {props.children}
  </button>
);
